module.exports = __webpack_public_path__ + "public-ui/img/tsb.192f8884.svg";